import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.css';
import './styles/app.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
